import React,  { useContext, useEffect, useState } from "react";
import { Badge, Container, Dropdown, Form, Nav, Navbar, NavDropdown, NavItem } from "react-bootstrap";
import { strings } from "../../services/Localization";

import { isMobile } from 'react-device-detect';
import { Button } from 'react-bootstrap';
import { IConstants } from "../../types";
import { IUser } from "../../dassTypes"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import userCustomerIcon from "../../../resources/images/user_customer.png";
import forwardUserIcon from "../../../resources/images/forward_user.png";
import ar from "../../../resources/images/ar.svg";
import hi from "../../../resources/images/hi.svg";
import en from "../../../resources/images/en.svg";
import fr from "../../../resources/images/fr.svg";
import es from "../../../resources/images/es.svg";
import it from "../../../resources/images/it.svg";

import AppContext, { IDassUiAppContext } from '../../context/AppContext'

import { faChartUser,faArrowUpRightFromSquare , faArrowRightFromBracket, faCircleInfo, faUserGear, faGlobe, faServer } from "@fortawesome/pro-light-svg-icons";
import { useNavigate } from "react-router";  
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import { SchemaModal } from "../SchemaModal/SchemaModal";
import { useWebSocket } from "../../pages/LiveLog/WebSocketLiveLog";
import { getDataFromSessionStorage } from "../../utils/sessionStorage";
import { faGears } from "@fortawesome/pro-regular-svg-icons";
import { useDataTableContext } from "../Common/DataTableEngine/shared/Context";

declare const constants: IConstants;

//const NavBar: React.FC<{}, INavbarState> = () => {

const NavBar: React.FC<{}> = (props) => {

    const AppContextObj = useContext(AppContext);
    const { startWebSocket, stopWebSocket } = useWebSocket();
    
    const portalEl: HTMLElement = document.createElement("div");

    let checkUser:boolean = AppContextObj.navBarState.user !== AppContextObj.user;    
    const { isBulkActionRunning } = useDataTableContext();

    useEffect(() => {
        if(AppContextObj.navBarState.user !== AppContextObj.user) {
            AppContextObj.setNavBarState(prevState => { return {...prevState, user: AppContextObj.user}})
        }
    },[checkUser])

    
    const activateButton = (id: string) => {
        let retry = 10; // continue to try for 2 seconds
        function tryit() {
            const obj = document.getElementById(id);
            if (obj && obj.click) {
                obj.click();
            } else {
                if (retry-- > 0) {
                    setTimeout(tryit, 200);
                }
            }
        }
        // wait 1 sec the start looking for the  button.
        setTimeout(tryit, 1000);
    }

    useEffect(() => {

        if (typeof AppContextObj.user?._environment?.ui_navbar_bg_color === "string") {
            document.documentElement.style.setProperty('--navbar-bg-color', AppContextObj.user._environment.ui_navbar_bg_color);
        }
        if (typeof AppContextObj.user?._environment?.ui_navbar_fg_color === "string") {
            document.documentElement.style.setProperty('--navbar-fg-color', AppContextObj.user._environment.ui_navbar_fg_color);
        }


        async function fetch() {
            
            document.body.insertBefore(portalEl, document.body.children[0]);

            try {
                const hashObj: any = {};
                if (window.location.hash) {
                    for (const arg of window.location.hash.slice(1).split("&")) {
                        const i = arg.indexOf("=");
                        if (i > 0) {
                            hashObj[arg.slice(0, i)] = decodeURIComponent(arg.slice(i + 1));
                        }
                    }
                }

                if (hashObj.click) {
                    AppContextObj.setNavBarState(prevState =>  { return {...prevState, click: hashObj.click }});
                }

            } catch (error) { console.log(error); }


            if (AppContextObj.navBarState.click) {
                activateButton(AppContextObj.navBarState.click);
            }


            
            if (localStorage.getItem('websocket_status') == "true" && AppContextObj.user?.userid) {
                if (getDataFromSessionStorage("liveloguser") !== AppContextObj.user?.userid) {
                    stopWebSocket();
                } else {
                    // Checking the LocalStorage to LiveLog Status to survive refresh
                    startWebSocket()
                }
            }

        }
        
        fetch();
        return () => {
            document.body.removeChild(portalEl);
            clearTimeout( AppContextObj.SessionCheck());
        }

    },[AppContextObj.user])




    const user = AppContextObj.user || ({} as IUser);
    return (
        <div id="navbar-root" className="besides-data-table" style={isBulkActionRunning ? { pointerEvents: 'none', opacity: 0.6 } : {}}>
             {
            AppContextObj.isSignedIn(user) && AppContextObj.isForwardedSignIn() && AppContextObj.navBarState.forwardedSignIn && 
            <div style={{backgroundColor : "#F6C457", width: "100%", textAlign:"center", padding: "5px"}}>
                <span>{strings.IMPERSONATE_ACCOUNT_MESSAGE}<b>{`${AppContextObj?.user?.userid}`}</b></span>
                <Button style={{marginLeft : "10px"}} variant="dark" size="sm" onClick={ () => { AppContextObj.retrnToOldUser() }}>
                    Exit
                </Button>
            </div>
        }
            {!isMobile && <DesktopMenu />}
            {isMobile && <MobileMenu  />}
        </div>
    );

}

export { NavBar };


let key = 0;

function skey() { key += 1; return key; }

const DesktopMenu:React.FC<{}> =  ( ) => {

    return (        
        <div className="desktop-menu">
            <div>
                <TopNavBar   />
            </div>
            <div >
                <MenuBar />
            </div>
        </div>
    )
}


const MobileMenu:React.FC<{}> =  ( props ) => {
    
    return (
        <div className="mobile-menu d-flex flex-row flex-grow-1 bg-dark position-relative" >
             <MobileMenuBar />
        </div>
    )
}

const TopNavBarMobile:React.FC<{}> = ( props ) => { 

    
    return (
        <Navbar className="top_header_desktop navbar navbar-dark bg-dark" style={{width: '100%'}} bg="dark" variant="dark">
                <RightMenuNav  />
        </Navbar>
    )
}




const userHasProp = (user,  prop ) => {
    
    if(user.hasOwnProperty(prop) && user[prop]) {
        return true;
    } else {
        return false;
    }
}

const MobileMenuBar:React.FC<{}> = () => {

    
    const AppContextObj = useContext(AppContext);
    
    return (
        <Navbar collapseOnSelect className="main_header_desktop flex-grow-1" expand="lg" bg="dark" variant="dark">
                <div className="d-flex flex-grow-1" style={{width: '100%'}}>
                    
                    <div className="d-flex flex-shrink-1" >
                        {AppContextObj.isSignedIn(AppContextObj.user) && <Navbar.Toggle />}
                    </div>
                    <div className="d-flex flex-grow-1 align-items-center ">
                        <AppLogoTitle />
                    </div>
                    <div className="d-flex flex-shrink-1" >
                        <TopNavBarMobile />
                    </div>
                </div>

                {AppContextObj.isSignedIn(AppContextObj.user) && <MainNavBar />}
        </Navbar>
                    
    )
}



const MainNavBar:React.FC<{}> = ({ }) => {

    const AppContextObj = useContext(AppContext);

    return (
            <Navbar.Collapse id="responsive-navbar-nav">

                <Nav className="main_header_desktop">
                <SchemaModal 
                    hooks={AppContextObj.navbarSchemaHook}
                    SchemaUrl="/rest/users?get_schema=navbar"
                    type="navbar"
                />
                </Nav>

            </Navbar.Collapse>
    )
}


export function cnvStorageUrl(u: string) {
    return u?.startsWith("storageid:") ? "/storagecache/" + u.substring(10) : u;
}

const AppLogoTitle:React.FC<{}> = ({ }) => {
    const appContext = useContext(AppContext);
    let user = appContext.user;
    let parentClasses = (isMobile) ? "d-flex flex-column justify-content-center align-items-start" : 'd-flex flex-row';
    const isNst = (String(location.pathname).indexOf('/nst'));
    const redirection = isNst != -1 ? "/nst/network_map" : "/app";
    const logoUrl = user?._environment?.ui_left_logo_url && typeof user._environment.ui_left_logo_url === "string"
                        ? cnvStorageUrl(user._environment.ui_left_logo_url)
                        : (constants.leftSideLogo ? constants.left_logo_file : "");

    const title = user?._environment?.ui_left_title && typeof user._environment.ui_left_title === "string"
                        ? user._environment.ui_left_title
                        : (constants.instance_title || "")

    return (
        <div className={parentClasses}>
            {logoUrl ? <a href={redirection}><img src={logoUrl} className="img-left-logo" /></a>
                     : <div className="fake_left_logo"></div>}

            <div className={`top_bar_name_instance_holder d-flex`}>

                {title &&  <div className="ms-1 instance_holder">{title.substring(0, 29)}</div>}

                {appContext.debugMessage && 
                    <div className="ms-1 instance_holder">
                        {appContext.debugMessage}
                    </div>
                }

                {user && user.account_status === "suspended" &&
                    <div className="ms-2 px-2  bg-warning rounded-pill instance_holder">
                        <FontAwesomeIcon icon={faTriangleExclamation} /> this account is currently suspended
                    </div>
                }
                {user && user.sys_admin && user._license_error &&
                    <div className="ms-2 px-2  bg-danger rounded-pill  instance_holder">
                        <FontAwesomeIcon icon={faTriangleExclamation} /> {user._license_error}
                    </div>
                }

            </div>
        </div>
    )
}

const MenuBar:React.FC<{}> = () => {

    const appContextObj = useContext(AppContext);

    return (
        <Navbar collapseOnSelect className="main_header_desktop px-2" expand="lg"  variant="dark" bg="dark">
            <Container fluid>
            {appContextObj.isSignedIn(appContextObj.user) && <Navbar.Toggle className="pull-left" />}
            {/*<FontAwesomeIcon icon={faHamburger} />*/}
            {appContextObj.isSignedIn(appContextObj.user) && <MainNavBar />}
            </Container>
        </Navbar>

    )
}

const TopNavBar:React.FC<{}> = ( ) => {

    return (
        <Navbar className="top_header_desktop navbar   px-2">
            <Container fluid>
                <AppLogoTitle   />
                <RightMenuNav  />
             </Container>
        </Navbar>
    )
}


export function languageMenu(appContext: IDassUiAppContext) {

    if (!(constants.languages?.length > 1)) {
        return null;
    }


    const languageToCountryCode = { en, ar, hi, fr, es, it };
    const languages = {
        en: strings.BUTTON_LANG_EN,
        zh: strings.BUTTON_LANG_ZH,
        fr: strings.BUTTON_LANG_FR,
        ar: strings.BUTTON_LANG_AR,
        hi: strings.BUTTON_LANG_HI,
        dd: strings.BUTTON_LANG_DD,
        es: strings.BUTTON_LANG_ES,
        it: strings.BUTTON_LANG_IT,
    };

    return (
        <NavDropdown
            title={isMobile ? (<FontAwesomeIcon icon={faGlobe} />) : (
                <span className="pull-left margin_lang">
                    {  <img 
                        src={languageToCountryCode[appContext.navBarState.language || "en"]}
                        style={{ width: 20, height: 15, marginRight: 5, marginBottom: 3 }} 
                    />}
                    { languages[appContext.navBarState.language || "en"] }
                </span>)}
            id="basic-nav-dropdown"
            className="shadow_dropdown lang_dropdown"
        >

            {constants.languages.filter(lang => languages[lang]).map((lang, idx) => (
            <Dropdown.Item key={lang} eventKey={8.0 + idx/10} onClick={appContext.changeLanguage } id={lang} active= {languages[appContext.navBarState.language || "en"] == languages[lang] } >
                {languageToCountryCode[lang] ? (
                <img 
                    src={languageToCountryCode[lang]}
                    style={{ width: 20, height: 15, marginRight: 10 }} 
                />) : " "}
                    {languages[lang]}
                </Dropdown.Item>
            ))}

        </NavDropdown>
    );
}

export function getLoginMenuTitle(appContext: IDassUiAppContext) {

    const user = appContext.user || ({} as IUser);

    if (user && appContext.navBarState.forwardedSignIn) {
        return (
            <span className="pull-left margin_lang">
                <b id="user_dropdown_item">{user?.userid}</b>
                <img src={forwardUserIcon} className="user_icon" id="user_icon1" />
            </span>
        );
        
    } else if (appContext.isSignedIn(user)) {
        return (
            <span className="pull-left">
                <b id="user_dropdown_item">{user?.userid}</b>
                {(userHasProp(user, 'administrator')  || userHasProp(user, 'customer_admin'))
                    ? <i className="fa-solid fa-fw fa-user-gear" id="user_icon2"></i> 
                    : <i className="fa-solid fa-fw fa-user" id="user_icon2"></i>}
            </span>
        );

    } else {
        return "";
    }
}



export function getLoginMenuUserItem(appContext: IDassUiAppContext) {
    const user = appContext.user || ({} as IUser);

    const loginId = user?.loginid ? <div>{user.loginid}</div> : null;
    let accountType = strings.TYPE_USER;

    if (user.is_organisation) { accountType = strings.ADMIN_TYPE_ORGANIZATION;
    } else if (user.customer_admin) { accountType = strings.ADMIN_TYPE_CUSTOMER;
    } else if (user.administrator) { accountType = strings.ADMIN_TYPE_USER;
    } else if (user.is_customer) { accountType = strings.TYPE_CUSTOMER;
    }

    if (appContext.isSignedIn(user) && !appContext.navBarState.forwardedSignIn) {
        return (
            <Dropdown.Item className="d-flex">
                <div> <img src={userCustomerIcon} className="img_user" /></div>
                <div> 
                    <div>{loginId}</div>
                    {<Badge bg="dark" >{accountType}</Badge>} 
                </div>
            </Dropdown.Item>
        );
    } else {
        return null;
    }

}





const RightMenuNav:React.FC<{}> = ({ }) => {

    const AppContextObj = useContext(AppContext);
    const navigate = useNavigate();

    const user = AppContextObj.user || ({} as IUser);
    const userenv = user._environment || {};
    const isNst = (String(location.pathname).indexOf('/nst') >= 0);
    

    // The NST switch is conditional and is check on rights here
    const canSwitchToNst = !user.app_uuid && Object.keys(user).filter(k => k.startsWith("omc_")).length > 0;

    // const userIsForwarded = AppContextObj.isSignedIn(user) && AppContextObj.isForwardedSignIn() && AppContextObj.navBarState.forwardedSignIn;

    // const rightMenuArr = [
    //     {
    //         type: 'dropdown',
    //         title: AppContextObj.navBarState.language === "en" ? strings.BUTTON_LANG_EN : strings.BUTTON_LANG_ZH,
    //         image: `/images/${AppContextObj.navBarState.language}_flag.png`,
    //         dropdownOptions : [
    //             {
    //                 title: strings.BUTTON_LANG_EN,
    //                 action: () => { AppContextObj.changeLanguage() },
    //                 image: `/images/${AppContextObj.navBarState.language}_flag.png`
    //             },
    //             {
    //                 title: strings.BUTTON_LANG_ZH,
    //                 action: () => { AppContextObj.changeLanguage() },
    //                 image: `/images/${AppContextObj.navBarState.language}_flag.png`
    //             }
    //         ]
    //     }
    // ]

     const accounts = (user.selectable_accounts || [])

    // Map language codes to country codes
    const [selectedAccount, setSelectedAccount] = useState(user?.userid); 

    useEffect(() => {
        setSelectedAccount(user?.userid);
    }, [user])
                                


    // Removed the flags for the moment
    //  <img src={`/images/${AppContextObj.navBarState.language}_flag.png`} className="img_language" />

    return (
        <Nav className="top_header">
            {languageMenu(AppContextObj)}

            {AppContextObj.isSignedIn(user) && (
                <NavDropdown
                    title={getLoginMenuTitle(AppContextObj)}
                    align={window.document.documentElement.dir === "rtl" ? "start" : "end"}
                    id="basic-nav-dropdown"
                    className="shadow_dropdown width_mobile"
                >

                    {getLoginMenuUserItem(AppContextObj)}

                    {AppContextObj.isSignedIn(user) && AppContextObj.navBarState.forwardedSignIn &&
                        <Dropdown.Item className="align-left" eventKey={1.1} >
                            <img src={userCustomerIcon} className="img_user_forward" />
                            <div className="forwarded_user">
                                {strings.NAV_SIGNED_AS} {user.userid} <br></br>
                                {strings.formatString(strings.VIA, {
                                    originalUser: AppContextObj.navBarState.originalUser,
                                })}
                                <br></br>
                                ({ user.customer_admin ? strings.ADMIN_TYPE_CUSTOMER : strings.ADMIN_TYPE_USER })
                            </div>
                        </Dropdown.Item>
                    }

                    {AppContextObj.isSignedIn(user) && !AppContextObj.navBarState.forwardedSignIn && <Dropdown.Divider />}

                    {AppContextObj.isSignedIn(user) && !AppContextObj.navBarState.forwardedSignIn && AppContextObj.user.loginid &&
                        <Dropdown.Item
                            className="align-left"
                            eventKey={1.2}
                            onClick={() => { navigate('app/user-settings')} }
                        >
                            <FontAwesomeIcon icon={faUserGear} ></FontAwesomeIcon>
                            {strings.NAV_USER_SETTINGS}
                        </Dropdown.Item>
                    }

                    {AppContextObj.isSignedIn(user) && !AppContextObj.navBarState.forwardedSignIn &&
                        <Dropdown.Item
                            className="align-left user-settings"
                            eventKey={1.3}
                            onClick={() => { navigate('app/account-settings')} }
                        >
                            <FontAwesomeIcon icon={faGears} ></FontAwesomeIcon>
                            {strings.NAV_ACCOUNT_SETTINGS}
                        </Dropdown.Item>
                    }

                    <Dropdown.Divider />


                    {AppContextObj.isSignedIn(user) && constants.server_type === 'dmp' &&
                        <Dropdown.Item
                            className="align-left user-settings"
                            eventKey={1.6}
                            onClick={() => { navigate('app/about')} }
                        >
                        <FontAwesomeIcon icon={faServer} ></FontAwesomeIcon>
                            {strings.NAV_ABOUT_SYSTEM}
                        </Dropdown.Item>
                    }
                                {/* {AppContextObj.isSignedIn(user) && AppContextObj.isForwardedSignIn() && AppContextObj.navBarState.forwardedSignIn &&
                                    <Dropdown.Item className="align-left user-settings" eventKey={1.3} onClick={ () => { AppContextObj.retrnToOldUser() }} >
                                        <FontAwesomeIcon icon={faPeopleArrowsLeftRight} ></FontAwesomeIcon>
                                        {strings.formatString(
                                            strings.NAV_RETURN_TO,
                                            { originalUser: AppContextObj.navBarState.originalUser },
                                        )}
                                    </Dropdown.Item>
                                } */}
                    {userenv.eula_id &&
                        <>
                            <Dropdown.Item
                                className=""
                                eventKey={1.5}
                                onClick={ () => { navigate("app/eula") } }
                            >
                                <FontAwesomeIcon icon={faCircleInfo} ></FontAwesomeIcon>
                                {strings.NAV_SOFTWARE_INFO}
                            </Dropdown.Item>
                        </>
                    }


                    {canSwitchToNst && 
                        <Dropdown.Item
                            eventKey={skey()}
                            href="#"
                            onClick={(e) => {
                                e.stopPropagation();
                                navigate(`nst/network_map`)                                    
                            }}
                            className="hover_menu dropdown-item"
                        >
                            <FontAwesomeIcon icon={faChartUser} ></FontAwesomeIcon>
                            {strings.NAV_SWITCH_TO_NST}
                            <span onClick={ (e) => { e.stopPropagation(); window.open("/nst/network_map") } }   className="mt-1 btn-link  float-end">
                                <FontAwesomeIcon size="xl"  icon={faArrowUpRightFromSquare} ></FontAwesomeIcon>
                            </span>
                        </Dropdown.Item>
                    }

                    {AppContextObj.isSignedIn(user) &&
                        <Dropdown.Item
                            className="align-left user-settings"
                            eventKey={1.4}
                            onClick={ () => { AppContextObj.signOut() }}
                        >
                        <FontAwesomeIcon icon={faArrowRightFromBracket} ></FontAwesomeIcon>
                            {strings.SIGN_OUT}
                        </Dropdown.Item>
                    }

                    { 
                        !isNst && accounts.length > 0 && (
                        <>
                            <Dropdown.Divider />
                            <Dropdown.Header>{strings.SWITCH_ACCOUNT}</Dropdown.Header>  
                                {accounts.map(accId => (
                                    
                                    <Dropdown.Item
                                        key={accId}
                                        className={`align-left user-settings ${
                                            selectedAccount === accId ? 'selected-radio' : ''
                                            }`}
                                        style={{ display: 'flex', alignItems: 'center', padding: '8px 12px' }}
                                        onClick={ async () => { 
                                            await AppContextObj.selectAccount(accId);
                                            navigate("/app");
                                        }}
                                    >
                                        <Form>
                                        <Form.Check
                                                inline
                                                label={accId}
                                                checked={selectedAccount === accId}
                                                name="group1"
                                                type="radio"
                                                id={`inline-${accId}`}
                                                style={{ margin: 0 }}
                                                onChange={() => setSelectedAccount(accId)}
                                            />
                                        </Form>
                                    </Dropdown.Item>
                                ))}
                        </>)
                    }
                                
    
                </NavDropdown>
            )}

            {!AppContextObj.isSignedIn(user) &&
                <a className="align-left sign-in" href="/app/signin" >
                    {strings.SIGN_IN}
                </a>
            }

            {constants.rightSideLogo &&
                <NavItem className="right_logo d-none d-md-block">
                    <div className="img-right-logo">
                        <img src={constants.right_logo_file} className="img-right-logo-img" />
                    </div>
                </NavItem>
            }
        </Nav>
    )
}




